import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useScrollRestoration } from '../../../../web/components/ScrollRestoration';
import { AgentTemplateDetail } from './AgentTemplateDetail';
import { AgentTemplatesList } from './AgentTemplatesList';

/**
 * Router for Sales AI Agent Templates in AIDA
 * Handles routing between list and detail views
 */
export function AgentTemplatesRouter() {
	const { path } = useRouteMatch();

	// The AIDA body scroll container persists across list↔detail navigation, so
	// without this the list jumps to the top when returning from a template.
	useScrollRestoration();

	return (
		<Switch>
			<Route exact path={path} component={AgentTemplatesList} />
			<Route path={`${path}/:id`} component={AgentTemplateDetail} />
		</Switch>
	);
}
